import { Divider } from 'antd';
import styled from 'styled-components';
export const HR = styled(Divider) `
  &&& {
    margin: 0;
    padding: 0;
  }
`;
export const ShadowBox = styled.div `
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  outline: none;
  padding: 0;
`;
// Covers an opening trigger, such as a Dropdown or Button component
export const ShiftShadowBox = styled(ShadowBox) `
  margin-left: -0.1rem;
  margin-top: -2.5rem;
`;
export * from './notice';
